var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.028,
    height: 16.861,
    viewBox: "0 0 21.028 16.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.913,
    y1: 0.756,
    x2: 0.117,
    y2: 0.138,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-1067 -492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M-13.527-4.139a.965.965,0,0,1-.709-.285L-18.481-8.8a.936.936,0,0,1,0-1.368,1.048,1.048,0,0,1,1.432,0l2.515,2.629V-20.03A.992.992,0,0,1-13.521-21a.986.986,0,0,1,1.014.969V-7.538l2.515-2.629a1.048,1.048,0,0,1,1.432,0,.936.936,0,0,1,0,1.368L-12.8-4.424a.966.966,0,0,1-.71.285Zm-11.521-.969V-17.6l-2.515,2.629a1.046,1.046,0,0,1-1.431,0,.936.936,0,0,1,0-1.368l4.244-4.375A.964.964,0,0,1-24.041-21h.013a.964.964,0,0,1,.709.284l4.244,4.375a.936.936,0,0,1,0,1.368,1.048,1.048,0,0,1-1.432,0L-23.021-17.6V-5.108a.986.986,0,0,1-1.013.969A.991.991,0,0,1-25.048-5.108Z",
    transform: "translate(1096.292 513)",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c337254103569631150f6d90e5af4dbc.svg";
export { ForwardRef as ReactComponent };